import { Config } from '@core/configuration';
import { Registry } from '@core/registry';
import { PrivatePlatformClient } from '@coveo-platform/private-platform-client';
import { ResponseHandlers } from './ResponseHandlers.js';
export var Platform = new PrivatePlatformClient({
    accessToken: function accessToken() {
        return Registry.get('access_token');
    },
    organizationId: function organizationId() {
        return Registry.get('organization_id');
    },
    host: Config.CloudPlatform.url,
    serverlessHost: Config.LogBrowser.url,
    responseHandlers: ResponseHandlers
});

//# sourceMappingURL=Platform.js.map